import React from 'react';

interface EazyLogoProps {
  size?: 'sm' | 'md' | 'lg';
  theme?: 'dark' | 'light';
}

const config = {
  sm: { icon: 22, rx: 5, bars: [{ x: 4, y: 4,  w: 14, h: 3, r: 1.5 }, { x: 4, y: 9,  w: 10, h: 3, r: 1.5 }, { x: 4, y: 15, w: 14, h: 3, r: 1.5 }], fontSize: 14, gap: 6 },
  md: { icon: 30, rx: 7, bars: [{ x: 6, y: 6,  w: 18, h: 4, r: 2   }, { x: 6, y: 13, w: 13, h: 4, r: 2   }, { x: 6, y: 20, w: 18, h: 4, r: 2   }], fontSize: 20, gap: 8 },
  lg: { icon: 42, rx: 10, bars: [{ x: 9, y: 9,  w: 24, h: 6, r: 3  }, { x: 9, y: 18, w: 18, h: 6, r: 3  }, { x: 9, y: 27, w: 24, h: 6, r: 3  }], fontSize: 26, gap: 12 },
};

const EazyLogo: React.FC<EazyLogoProps> = ({ size = 'md', theme = 'dark' }) => {
  const c = config[size];
  const iconBg   = theme === 'dark' ? '#1e2a45' : '#e0f2fe';
  const bar1     = theme === 'dark' ? '#38bdf8' : '#0284c7';
  const bar2     = '#6366f1';
  const wordEazy = '#38bdf8';
  const wordProj = theme === 'dark' ? '#ffffff' : '#1a1a2e';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: c.gap, flexShrink: 0 }}>
      <svg width={c.icon} height={c.icon} viewBox={`0 0 ${c.icon} ${c.icon}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width={c.icon} height={c.icon} rx={c.rx} fill={iconBg} />
        <rect x={c.bars[0].x} y={c.bars[0].y} width={c.bars[0].w} height={c.bars[0].h} rx={c.bars[0].r} fill={bar1} />
        <rect x={c.bars[1].x} y={c.bars[1].y} width={c.bars[1].w} height={c.bars[1].h} rx={c.bars[1].r} fill={bar2} />
        <rect x={c.bars[2].x} y={c.bars[2].y} width={c.bars[2].w} height={c.bars[2].h} rx={c.bars[2].r} fill={bar1} />
      </svg>
      <span style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '-0.5px', lineHeight: 1, fontSize: c.fontSize }}>
        <span style={{ fontWeight: 300, color: wordEazy }}>eazy</span>
        <span style={{ fontWeight: 700, color: wordProj }}>project</span>
      </span>
    </div>
  );
};

export default EazyLogo;
